import React from 'react';
import styled from 'styled-components';

import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';

interface Props {
  email: string;
}

export const ResendEmailConfirmationForm: React.FC<Props> = ({ email }) => (
  <>
    <Title>
      Перейдите по ссылке <br /> из письма
    </Title>
    <StyledDescription>
      На вашу почту <StyledEmail>{email}</StyledEmail> отправлено письмо с
      подтверждением.
    </StyledDescription>
    <StyledDescription>
      Если вы его не получили,
      <br />
      проверьте папку «Спам»
    </StyledDescription>
    <Content>
      <EmailButton email={email} />
    </Content>
  </>
);

const StyledDescription = styled(Description)`
  padding: 0;
`;

const StyledEmail = styled.span`
  font-weight: bold;
`;
